import { FieldTypeCategory } from '@thinkalpha/language-services';
import type { ColumnTemplate, TemplateColumn } from '@thinkalpha/ui-types/contracts/column-template';
import type { DisplaySettings, GridDisplaySettings } from '@thinkalpha/ui-types/contracts/display/settings';
import { v4 } from 'uuid';

export const generateDefaultGridSetting = (): GridDisplaySettings => ({
    id: v4(),
    condition: { type: 'noop' },
    formatting: {},
    styles: {
        background: {},
        cellStyles: {},
        font: {},
        rowBackground: {},
        text: {},
    },
});

export const generateWorkableColumnTemplateGridSettings = (gridSettings: ColumnTemplate): ColumnTemplate => {
    const { gridDisplaySettings = [generateDefaultGridSetting()] } = gridSettings;

    const sanitizedGrid = gridDisplaySettings.find((x) => x.condition.type === 'noop')
        ? gridDisplaySettings
        : [generateDefaultGridSetting(), ...gridDisplaySettings];

    return {
        ...gridSettings,
        gridDisplaySettings: sanitizedGrid,
        rowBasedDisplaySettings: gridSettings.rowBasedDisplaySettings ?? [],
        columns: gridSettings.columns.map<TemplateColumn>((col) => ({
            ...col,
            displaySettings:
                !col.displaySettings || col.displaySettings.length === 0
                    ? [
                          {
                              id: v4(),
                              condition: {
                                  type: 'noop',
                              },
                              formatting: {},
                              styles: {},
                          },
                      ]
                    : col.displaySettings,
        })),
    };
};

export const generateDefaultDisplaySetting = (): DisplaySettings => ({
    id: v4(),
    condition: {
        type: 'noop',
    },
    formatting: {},
    styles: {
        background: {},
        cellStyles: {},
        font: {},
        rowBackground: {},
        text: {},
    },
});

export const templateColumnFactory = (): TemplateColumn => {
    return {
        displaySettings: [
            {
                ...generateDefaultDisplaySetting(),
            },
        ],
        formula: '',
        imports: [],
        id: v4(),
        name: 'New Column',
        dataType: FieldTypeCategory.Double,
        type: 'formula',
        unit: null,
        visible: true,
    };
};
